<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top:50%">
      <small class="text-muted">Cargando...</small><br />
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <div class="dz-banner-heading">
        <div class="overlay-black-light">
          <img v-bind:src="aliado.pieza_app" class="bnr-img" alt="">
        </div>
      </div>
      <div class="container company-detail">
          <div class="media media-60">
              <img  v-bind:src="aliado.logo_app" class="img-thumbnail"
                v-bind:alt="aliado.nombre_aliado">
          </div>
          <div class="detail-content">
              <div class="flex-1">
                  <h4 class="text-primary">{{ aliado.nombre_aliado }}</h4>
                  <i class="fas fa-map-marker-alt me-1"></i> Zona
                    <p v-if="aliado.zona == 1" class="ms-1">
                      Norte</p
                    >
                    <p v-if="aliado.zona == 2" class="ms-1"> Sur</p>
                    <p v-if="aliado.zona == 3" class="ms-1">
                      Este</p
                    >
                    <p v-if="aliado.zona == 4" class="ms-1">
                      Oeste</p
                    >
                    <p v-if="aliado.zona == 5" class="ms-1">
                      Centro</p
                    >
              </div>
              <div class="text-end">
                <div v-if="loading_valoracion">
                  <div class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="valoracion != null && valoracion > 0">
                    <h4 class="text-orange float-end pt-2 mb-3">
                      <i class="bx bxs-star"></i> {{ valoracion }}
                    </h4>
                  </div>
                </div>
              </div>
          </div>
          <div class="card card-body shadow mt-4">
            <ul class="contact-box">
              <li class="d-flex align-items-center" v-if="aliado.telefono">
                <a href="javascript:void(0);" class="contact-icon">
                  <i class="fa fa-phone" style="font-size: 1.3em"></i>
                </a>
                <div class="ms-3">
                  <p class="mb-2">Teléfono</p>
                  <h6>
                    <a href="javascript:void(0);">{{ aliado.telefono }}</a>
                  </h6>
                </div>
              </li>
              <li class="d-flex align-items-center my-3" v-if="aliado.whatsapp">
                <a v-bind:href="'https://api.whatsapp.com/send?phone=57'+aliado.whatsapp"  class="contact-icon" target="_blank">
                  <i class="fab fa-whatsapp" style="font-size: 1.6em"></i>
                </a>
                <div class="ms-3">
                  <p class="mb-2">WhastApp</p>
                  <h6>
                    <a v-bind:href="'https://api.whatsapp.com/send?phone=57'+aliado.whatsapp" target="_blank">{{
                      aliado.whatsapp
                    }}</a>
                  </h6>
                </div>
              </li>
              <li class="d-flex align-items-center my-3" v-if="aliado.facebook">
                <a v-bind:href="'https://facebook.com/'+aliado.facebook" class="contact-icon" target="_blank">
                  <i class="fab fa-facebook" style="font-size: 1.6em"></i>
                </a>
                <div class="ms-3">
                  <h6>
                    <a v-bind:href="'https://facebook.com/'+aliado.facebook" target="_blank">{{
                      aliado.nombre_aliado
                    }}</a>
                  </h6>
                </div>
              </li>
              <li class="d-flex align-items-center my-3" v-if="aliado.instagram">
                <a v-bind:href="'https://instagram.com/'+aliado.instagram" class="contact-icon" target="_blank">
                  <i class="fab fa-instagram" style="font-size: 1.6em"></i>
                </a>
                <div class="ms-3">
                  <h6>
                    <a  v-bind:href="'https://instagram.com/'+aliado.instagram" target="_blank">{{
                      aliado.nombre_aliado
                    }}</a>
                  </h6>
                </div>
              </li>
            </ul>

            <div class="about-company mt-3 mb-3" v-if="aliado.alianza.descripcion">
              {{aliado.alianza.descripcion}}
            </div>

            <div class="text-end mt-3">
              <button
                v-if="!aliado.favorito"
                v-on:click="set_favorito"
                class="btn btn-outline-warning btn-sm rounded-pill"
              >
                <i class="fa-regular fa-star"></i>
                Añadir a favoritos
              </button>
              <button
                v-else
                v-on:click="set_favorito"
                class="btn btn-warning btn-sm rounded-pill"
              >
                <i class="fa-solid fa-star"></i>
                Quitar de favoritos
              </button>
            </div>
          </div>

          <div class="card card-body shadow" v-if="aliado.lat || aliado.lng">
            <GmapMap
              :center="center"
              :zoom="15"
              map-type-id="terrain"
              style="width: auto; height: 300px"
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                @click="center = m.position"
              />
            </GmapMap>
          </div>

          <div v-if="aliado.comentarios != null" class="card card-body shadow">
            <ul class="dz-list message-list">
              <li
                v-for="(comentario, index_comentario) in aliado.comentarios"
                v-bind:key="index_comentario"
              >
                <a href="javascript:void(0)">
                  <div class="media media-45 rounded-circle">
                    <img src="assets/images/user_msg.png" alt="User" />
                  </div>
                  <div class="media-content">
                    <div>
                      <h6 class="name">{{ comentario.usuario }}</h6>
                      <p class="my-1">
                        {{ comentario.comentario }}
                      </p>
                    </div>
                    <span class="time">{{ comentario.fecha }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
       </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Aliado",
  metaInfo: {
    title: "Aliado - Reddy App",
  },
  data() {
    return {
      loading: true,
      loading_valoracion: true,
      id_aliado: null,
      aliado: null,
      valoracion: null,
      center: null,
      markers: [
        {
          position: {
            lat: 3.4773271608968983,
            lng: -76.50223035435835,
          },
        },
      ],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.get_aliado();
    this.get_valoracion();
  },
  methods: {
    get_aliado: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          favorito: 1,
          comentarios: 1,
        },
      };
      const vm = this;
      axios
        .get(this.$base_url + "aliados/aliado/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            this.aliado = response.data.data;
            if (this.aliado.estado_app != 1) {
              vm.$notify({
                type: "error",
                group: "foo",
                title: "<i class='fa fa-exclamation-circle'></i> Ups!",
                text: "No se encontró el aliado.",
              });
              this.$router.push("/");
            }
            this.center = {
              lat: parseFloat(this.aliado.lat),
              lng: parseFloat(this.aliado.lng),
            };
            this.markers[0] = {
              position: {
                lat: parseFloat(this.aliado.lat),
                lng: parseFloat(this.aliado.lng),
              },
            };
          }
          this.loading = false;
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_valoracion: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {},
      };
      const vm = this;
      axios
        .get(this.$base_url + "aliados/valoracion/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            this.valoracion = response.data.data.promedio;
          }
          this.loading_valoracion = false;
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
    set_favorito: function () {
      var estado = 1;
      if (this.aliado.favorito == 1) {
        estado = 0;
      }
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let params = {
        id_aliado: this.id_aliado,
        estado: estado,
      };
      axios
        .post(this.$base_url + "membresias/set_favorito", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            vm.get_aliado();
          }
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
  },
  mounted: function () {},
};
</script>
